export default __webpack_public_path__ + "static/media/icono-info-circle.9518e3ae.svg";